// removed by extract-text-webpack-plugin
module.exports = {"icon":"feature__icon___8pJMJ","title":"feature__title___1BLVU","copy":"feature__copy___Vqq2v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Feature/feature.css
// module id = 285
// module chunks = 1